import * as React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from '@mui/material';

export default function CustomSelect({ name, label, options, values, onChange }) {
  return (
    <Box width={250} className='m-2'>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          value={values}
          name={name}
          label={label}
          onChange={onChange}
          // renderValue={(selected) => (
          //   <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          //     {selected.map((val) => (
          //       <Chip
          //         key={val}
          //         label={val}
          //         // onDelete={() => handleDelete(val)}
          //         sx={{ cursor: 'pointer' }}
          //       />
          //     ))}
          //   </Box>
          // )}
        >
          {options?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
